import { axiosV1 } from 'interceptors/axios';
import { store } from 'redux/store';
import { addAlert } from 'modules/_shared/redux/alertActions';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';

import { decryptResponse } from './token';

async function downloadSingleDocument({ documentId, documentName }) {
  try {
    const { data } = await axiosV1.get(`/download/${documentId}`);
    const decodedData = await decryptResponse(data);
    const url = decodedData?.url;

    if (!url) {
      // eslint-disable-next-line no-console
      console.error('No URL found in decoded data:', decodedData);
      store.dispatch(addAlert(alertBodyTypes.ERROR_DOWNLOADING_DOCUMENT));
      return;
    }

    // For presigned URLs (S3/Google Cloud), use direct navigation to avoid CORS issues
    // Create a link and trigger download directly from the URL
    const link = document.createElement('a');
    link.href = url;
    link.download = documentName || 'document';
    link.target = '_blank'; // Open in new tab as fallback
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    store.dispatch(addAlert(alertBodyTypes.ERROR_DOWNLOADING_DOCUMENT));
  }
}

export default async function downloadDocument({
  documentId = '',
  documentName = '',
  multiple = false,
  documents,
}) {
  if (multiple) {
    documents.forEach((document) => {
      downloadSingleDocument({
        documentId: document['_id'],
        documentName: document?.name,
      });
    });
  } else {
    downloadSingleDocument({ documentId, documentName });
  }
}

export async function getSingleDocument(documentId) {
  const { data } = await axiosV1.get(`/download/${documentId}`);
  const decodedData = await decryptResponse(data);
  const url = decodedData?.url;
  const result = fetch(url)
    .then((response) => response.blob())
    .then((blob) => blob)
    .catch(() => {
      store.dispatch(addAlert(alertBodyTypes.ERROR_DOWNLOADING_DOCUMENT));
    });
  return result;
}
